import React from "react";
import Box from "@mui/material/Box";
import { DeleteIcone } from "../../../../../components/UI/Icons";
import ProtectedImage from "../../../../../components/ProtectedImage";
import CustomDateFormatter from "../../../../../utils/dateTimeFormatter";
import downloadImg from "../../../../../styles/svg/download.svg";

function AttachmentItem({
  item,
  isMobile,
  handleSlideShowAttachment,
  handleView,
  handleDownload,
  handleDelete,
}) {
  return (
    <Box
      onClick={() => {
        item.attachment_type === "pdf"
          ? handleView(item.card_attachment_id)
          : handleSlideShowAttachment(item.card_attachment_id);
      }}
      height={isMobile ? "auto" : 121}
      width={150}
      my={0}
      mx={0}
      alignItems="center"
      gap={0}
      p={0}
      className="detail-attachment-box-item"
    >
      <div className="attachment-img">
        <div className="icons">
          <div
            className="attachment-download"
            onClick={(e) => {
              e.stopPropagation();
              handleDownload(item.card_attachment_id);
            }}
          >
            <img src={downloadImg} alt="" />
          </div>
          <div
            className="attachment-delete"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(item.card_attachment_id);
            }}
          >
            <DeleteIcone height={"20px"} width={"20px"} />
          </div>
        </div>

        {item.attachment_type.toLowerCase() === "jpg" ||
        item.attachment_type.toLowerCase() === "jpeg" ||
        item.attachment_type.toLowerCase() === "png" ? (
          <div className=" attachment-overlay">
            <ProtectedImage
              name={item.data}
              className="attachment-img-data "
              alt=""
            />
          </div>
        ) : (
          <div className="attachment-img-type attachment-overlay">
            <p>{item.attachment_type}</p>
          </div>
        )}
      </div>
      <div className="attachment-detail">
        <div>
          <div>
            <p className="attachment-name">{item.attachment_name}</p>

            <div className="attachment-date">
              <CustomDateFormatter date={item.date_added} />
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}

export default AttachmentItem;
